import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=220bf3da&scoped=true"
import script from "./Pending.vue?vue&type=script&lang=js"
export * from "./Pending.vue?vue&type=script&lang=js"
import style0 from "./Pending.vue?vue&type=style&index=0&id=220bf3da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bf3da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('220bf3da')) {
      api.createRecord('220bf3da', component.options)
    } else {
      api.reload('220bf3da', component.options)
    }
    module.hot.accept("./Pending.vue?vue&type=template&id=220bf3da&scoped=true", function () {
      api.rerender('220bf3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/po/Pending.vue"
export default component.exports